import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import styles from "./bottom_tab.module.css"; // Import the CSS module
import { EditOutlined, GlobalOutlined, HomeOutlined, UserAddOutlined } from "@ant-design/icons";
import Agent from "../header/agent";
import About from "../header/about";
import CancelBooking from "../header/cancel_booking";
import BookingManagment from "./booking_management";
import AgentManagment from "./agent_management";
import MemberManagment from "./member_managment";
import { BookingDataContext } from "containers/data_context";
import UserInfo from "./user_info";

export default function BottomTabs({ property = {} }) {
  const { channelId } = useContext(BookingDataContext);
  const [visible, setVisible] = useState(true);
  const [showMemberLogin, setShowMemberLogin] = useState(false);

  const [showPropertyInfo, setPropertyInfo] = useState(false);
  const [isBookingSheetOpen, setIsBookingSheetOpen] = useState(false);
  const [showMemberInfo, setShowMemberInfo] = useState(false);

  const [showAgentSheet, setShowAgentSheet] = useState(false);
  const userInfo = useMemo(() => {
    return JSON.parse(localStorage.getItem("userInfo"));
  }, [JSON.parse(localStorage.getItem("userInfo"))]);

  const isLoggedIn = useMemo(() => {
    return userInfo && userInfo?.channelId === channelId;
  }, [userInfo, channelId]);

  let timeout;

  const handleScroll = useCallback(() => {
    setVisible(true);
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (!showAgentSheet && !showMemberInfo && !isBookingSheetOpen && !showMemberLogin) {
        setVisible(false);
      }
    }, 3000);
  }, [showAgentSheet, showMemberInfo, isBookingSheetOpen, showMemberLogin]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, [showAgentSheet, showMemberInfo, isBookingSheetOpen, showMemberLogin]);

  return (
    <div className={`${styles.bottom_tabs} ${visible ? "" : styles.hidden}`}>
      <div className={styles.bottom_tabs_container}>
        <button
          type="button"
          onClick={() => {
            setPropertyInfo(true);
            setShowAgentSheet(false);
            setIsBookingSheetOpen(false);
            setShowMemberInfo(false);
            setShowMemberLogin(false);
          }}
        >
          <HomeOutlined />
        </button>
        <button
          type="button"
          onClick={() => {
            setShowAgentSheet(!showAgentSheet);
            setPropertyInfo(false);
            setIsBookingSheetOpen(false);
            setShowMemberInfo(false);
            setShowMemberLogin(false);
          }}
        >
          <GlobalOutlined />
        </button>
        <button
          type="button"
          onClick={() => {
            setPropertyInfo(false);
            setShowAgentSheet(false);
            setShowMemberInfo(false);
            setShowMemberLogin(false);

            setIsBookingSheetOpen(!isBookingSheetOpen);
          }}
        >
          <EditOutlined />
        </button>

        <button
          type="button"
          onClick={() => {
            if (isLoggedIn) {
              setShowMemberLogin(false);
              setPropertyInfo(false);
              setShowAgentSheet(false);
              setIsBookingSheetOpen(false);
              setShowMemberInfo(!showMemberInfo);
            } else {
              setShowMemberLogin(!showMemberLogin);
              setPropertyInfo(false);
              setShowAgentSheet(false);
              setIsBookingSheetOpen(false);
              setShowMemberInfo(false);
            }
          }}
        >
          <UserAddOutlined />
          {/* {!Boolean(isLoggedIn) ? <LoginOutlined /> : <LogoutOutlined />} */}
        </button>
      </div>
      {/* Bottom Sheet */}

      <BookingManagment open={isBookingSheetOpen} setOpen={setIsBookingSheetOpen} />
      <AgentManagment open={showAgentSheet} setOpen={setShowAgentSheet} />
      <MemberManagment open={showMemberLogin} setOpen={setShowMemberLogin} />
      <UserInfo userInfo={userInfo} open={showMemberInfo} setOpen={setShowMemberInfo} />

      <About property={property} showModal={showPropertyInfo} setShowModal={setPropertyInfo} />
    </div>
  );
}
